var RemovalSet =
/** @class */
function () {
  function RemovalSet() {
    this.toDelete = [];
    this.toDeleteSize = 0;
    this._set = new Set();
  }

  RemovalSet.prototype.add = function (t) {
    this._set.add(t);
  };

  RemovalSet.prototype.forEach = function (f) {
    this._set.forEach(f);

    this.flush();
  };

  RemovalSet.prototype.delete = function (t) {
    if (this.toDelete.length === this.toDeleteSize) {
      this.toDelete.push(t);
    } else {
      this.toDelete[this.toDeleteSize] = t;
    }

    this.toDeleteSize++;
  };

  RemovalSet.prototype.flush = function () {
    for (var i = 0; i < this.toDelete.length; i++) {
      if (i < this.toDeleteSize) {
        this._set.delete(this.toDelete[i]);
      }

      this.toDelete[i] = undefined;
    }

    this.toDeleteSize = 0;
  };

  return RemovalSet;
}();

export default RemovalSet;